import { render, staticRenderFns } from "./lose-name.vue?vue&type=template&id=8b2163ac&scoped=true&"
import script from "./lose-name.vue?vue&type=script&lang=js&"
export * from "./lose-name.vue?vue&type=script&lang=js&"
import style0 from "./lose-name.vue?vue&type=style&index=0&id=8b2163ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2163ac",
  null
  
)

export default component.exports